import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export function TooltipPortal({ children, position }) {
  const el = useRef(document.createElement("div"));

  useEffect(() => {
    const current = el.current;
    document.body.appendChild(current);
    return () => {
      document.body.removeChild(current);
    };
  }, []);

  return createPortal(
    <div
      style={{
        position: "fixed",
        left: position.left,
        top: position.top,
        minWidth: "120px",
        zIndex: 9999,
        pointerEvents: "none",
        background: "rgba(0,0,0,0.85)",
        color: "white",
        borderRadius: "0.25rem",
        padding: "0.5rem",
        fontSize: "0.85rem",
        whiteSpace: "pre-line",
      }}
    >
      {children}
    </div>,
    el.current
  );
}
